"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var utils_1 = require("../utils");
function findException(xml) {
    var _a;
    return (_a = ((0, utils_1.findTagText)(xml, "ows:ExceptionText") ||
        (0, utils_1.findTagText)(xml, "ServiceException"))) === null || _a === void 0 ? void 0 : _a.trim();
}
exports.default = findException;
